export default {
  // Errors
  notFound: 'City not found',

  // Words
  city: 'City',
  enterCity: 'Enter city'
}